import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../h2Api'
import * as editPersonalProfileActions from '../actions/editPersonalProfile'
import { initialEditForm } from '../actions/profileCommon'

const initialMgmtRequest = {
  confirmationDetails: null,
  fields: {
    teacherId: '',
    requestType: 1
  },
  errors: {}
}
const initialManagementState = {
  managers: [],
  managementRequest: initialMgmtRequest,
  modalParams: {},
  isModalOpen: false
}
const initialScreenState = {
  tabId: 'personalInfo' //"personalInfo" // "resetPassword" "collegePreferences"
}
const profileSave = (state = h2Api.handleRest(), action) => {
  switch (action.type) {
    case editPersonalProfileActions.EDIT_PROFILE_SAVE: {
      return {
        ...state,
        ...h2Api.handleRest(action)
      }
    }

    default:
      return state
  }
}
const screen = (state = initialScreenState, action) => {
  switch (action.type) {
    case editPersonalProfileActions.EDIT_PROFILE_CLICK_TAB:
      return {
        ...state,
        tabId: action.tabId
      }

    default:
      return state
  }
}
const management = (state = initialManagementState, action) => {
  switch (action.type) {
    case editPersonalProfileActions.FETCH_MANAGEMENT_STATUS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          managers: action.restCall.result || []
        }
      }

      return state

    case editPersonalProfileActions.MANAGEMENT_REMOVE_RELATION:
      return {
        ...state,
        managers: state.managers.filter(m => m.user.id !== action.managerId)
      }

    case editPersonalProfileActions.REQUEST_MGMT_BY_CODE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          managementRequest: initialMgmtRequest,
          managers: state.managers.concat([action.restCall.result.record]),
          isModalOpen: !state.isModalOpen
        }
      }

      return state

    case editPersonalProfileActions.TOGGLE_MODAL:
      return {
        ...state,
        isModalOpen: !state.isModalOpen,
        modalParams: action.params
      }

    case editPersonalProfileActions.EDIT_MANAGEMENT_MODAL_CHANGE:
      console.log(action.fieldValue)

      return {
        ...state,
        managementRequest: {
          ...state.managementRequest,
          fields: {
            ...state.managementRequest.fields,
            ...action.fieldValue
          }
        }
      }

    case editPersonalProfileActions.LOOKUP_MANAGER_ID:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        if (action.restCall.result.error) {
          return {
            ...state,
            managementRequest: {
              ...state.managementRequest,
              errors: {
                teacherId: action.restCall.result.error
              }
            }
          }
        }

        return {
          ...state,
          managementRequest: {
            ...state.managementRequest,
            confirmationDetails: action.restCall.result
          }
        }
      }

      return state

    default:
      return state
  }
}

export default combineReducers({
  screen,
  management,
  profileSave,
  editForm: modelReducer('editPersonalProfile.editForm', initialEditForm),
  forms: formReducer('editPersonalProfile', { editForm: initialEditForm })
})
